angular.module('lf.desktop')

.directive('tooltipsy', function () {
  return function (scope, el, attrs) {
    // Ignore if iOS
    var iOS = /ip(ad|hone|od)/i.test(navigator.userAgent);
    if (iOS) return;
    
    // http://tooltipsy.com/options
    var defaults = {
      delay: 100
    }
    var opts = $.extend({}, defaults, (attrs.tooltipsyOptions || {}));
    var tooltipsy;
    
    el.tooltipsy(opts);
    tooltipsy = el.data('tooltipsy');
    
    scope.$on('$destroy', function () {
      if (tooltipsy) tooltipsy.destroy();
    });
  }
});